module.exports = __webpack_public_path__ + "img/dragfree.9784839c.png";